import PortalClienteService from "services/bases/PortalClienteService";

class AgendamentosLicenciamentoService extends PortalClienteService {
    async ObterAgendamentoPorUsuario(usuarioId) {
        return await this.get(`AgendamentosLicenciamento/ObterAgendamentoPorUsuario?usuarioId=${usuarioId}`);
    }

    async CriarAgendamento(data) {
        return await this.post(`AgendamentosLicenciamento`, data);
    }

    async CancelarAgendamento(data) {
        return await this.patch(`AgendamentosLicenciamento/Cancelar`, data);
    }
}

export default new AgendamentosLicenciamentoService();